import axios from 'axios'
import notifService from '../../services/notifService'

export const getEmployee = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/employees', {
      params: pagination
    })
    .then(response => {
      commit('getEmployee', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addEmployee = async (_context, val) => {
  return await axios
    .post('/cms/employees/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      notifService.notif(
        'apiRes',
        error.response ? error.response.data.message : 'FE',
        'error'
      )

      return false
    })
}

export const editEmployee = async (_context, val) => {
  return await axios
    .put('/cms/employees/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      notifService.notif(
        'apiRes',
        error.response ? error.response.data.message : 'FE',
        'error'
      )
      return false
    })
}

export const deleteEmployee = async (_context, val) => {
  let res = await axios
    .delete('/cms/employees/delete/' + val.id)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const updateSubordinate = async ({ dispatch }, val) => {
  let res = await axios
    .post('/cms/employees/subordinate', val)
    .then(response => {
      dispatch('getEmployee')
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const employeeArea = async (_context, val) => {
  let res = await axios
    .post('/cms/employees/area', val)
    .then(response => {
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const employeeForm = ({ commit }, val) => {
  commit('employeeForm', val)
}

export const employeeFormReset = ({ commit }) => {
  commit('employeeFormReset')
}

export const getPositions = async ({ commit }, pagination) => {
  return await axios
    .get('/cms/positions', {
      params: pagination
    })
    .then(response => {
      commit('getPositions', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const getListPosition = async ({ commit }) => {
  let res = await axios
    .get('/cms/positions', {
      params: {
        per_page: 50
      }
    })
    .then(response => {
      commit('getListPosition', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addPosition = async (_context, val) => {
  return await axios
    .post('/cms/positions/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const editPosition = async (_context, val) => {
  return await axios
    .put('/cms/positions/edit/' + val.id, {
      name: val.name
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deletePosition = async (_context, val) => {
  return await axios
    .delete('/cms/positions/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response)
        notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const positionForm = ({ commit }, val) => {
  commit('positionForm', val)
}

export const employeeTableSort = (context, val) => {
  context.commit('employeeTableSort', val)
}

export const getDivisions = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/divisions', {
      params: pagination
    })
    .then(response => {
      commit('getDivisions', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addDivision = async (_context, val) => {
  let res = await axios
    .post('/cms/divisions/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const editDivision = async (_context, val) => {
  let res = await axios
    .put('/cms/divisions/edit/' + val.id, {
      name: val.name
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const deleteDivision = async (_context, val) => {
  let res = await axios
    .delete('/cms/divisions/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return error
    })

  return res
}

export const divisionForm = ({ commit }, val) => {
  commit('divisionForm', val)
}

export const divisionFormReset = ({ commit }) => {
  commit('divisionFormReset')
}
